module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ed-wrap"
  }, [_c('modal', {
    staticClass: "ed-modal",
    attrs: {
      "name": "question",
      "adaptive": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 620
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "ed-dialog"
  }, [_c('div', {
    staticClass: "ed-dialog-header"
  }, [_c('div', {
    staticClass: "ed-dialog-header-left"
  }, [_c('span', {
    staticClass: "ed-dialog-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 3v18h18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 15l4-4 3 3 5-7"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "ed-dialog-title"
  }, [_vm._v("Edit Distance")]), _vm._v(" "), _c('p', {
    staticClass: "ed-dialog-sub"
  }, [_vm._v(_vm._s(_vm.finishDate) + " · " + _vm._s(_vm.race.duration) + " · " + _vm._s(_vm.race.name))])])]), _vm._v(" "), _c('button', {
    staticClass: "ed-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('question')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ed-dialog-body"
  }, [_c('div', {
    staticClass: "ed-current-distance"
  }, [_vm._v(_vm._s(_vm.race.distance))]), _vm._v(" "), _c('label', {
    staticClass: "ed-field"
  }, [_c('span', {
    staticClass: "ed-label"
  }, [_vm._v("Distance")]), _vm._v(" "), _c('div', {
    staticClass: "ed-input-unit"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newdistance),
      expression: "newdistance"
    }],
    staticClass: "ed-input",
    attrs: {
      "type": "number",
      "id": "save-distance-input",
      "maxlength": "255",
      "name": "newdistance",
      "placeholder": "0.00"
    },
    domProps: {
      "value": (_vm.newdistance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newdistance = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ed-unit"
  }, [_vm._v("Km")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ed-dialog-footer"
  }, [_c('button', {
    staticClass: "ed-cancel-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('question')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ed-save-btn",
    attrs: {
      "id": "save-distance",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.Save(_vm.newdistance)
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37164ea8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/EditDistance.vue
// module id = 1693
// module chunks = 2